import "../App.css";

export default function AboutMe() {
  return (
    <div
      className="tab-pane fade about-me"
      id="about-me-tab-pane"
      role="tabpanel"
      aria-labelledby="about-me-tab"
      tabIndex="0"
    >
      <section id="about" className="about">
        <div className="container-fluid">
          <div className="row">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item" aria-current="page">
                  <small>
                    <code>$ ~/portfolio/src/components/AboutMe.js</code>
                  </small>
                </li>
              </ol>
            </nav>
          </div>
          <h2 className="mb-4">About Me</h2>
          <p className="text-justify">
            Hi, I'm <strong>Sunday Oruwhone</strong>! I'm a passionate{" "}
            <strong>Software Engineer</strong> and{" "}
            <strong>Frontend Developer</strong> with{" "}
            <strong>6+ years of experience</strong> building scalable,
            responsive web applications. I specialize in pixel-perfect
            implementations using modern technologies like{" "}
            <strong>React, Next.js, and TypeScript</strong>, and I love
            mentoring budding developers.
          </p>

          <h3 className="mt-4">What I Do</h3>
          <ul className="list-unstyled">
            <li>
              🚀 Architect and engineer scalable front-end solutions with{" "}
              <strong>React.js, Next.js, and TypeScript</strong>.
            </li>
            <li>
              👨‍💻 Lead and mentor developer teams in <strong>Agile/Scrum</strong>{" "}
              environments, ensuring high-quality project delivery.
            </li>
            <li>
              🛠 Optimize performance through{" "}
              <strong>code-splitting, lazy loading, and CI/CD pipelines</strong>{" "}
              (GitHub Actions, Vercel).
            </li>
            <li>
              🎨 Craft responsive designs with{" "}
              <strong>Tailwind CSS, Material UI, and Bootstrap</strong>.
            </li>
            <li>
              📚 Tutor and train aspiring developers in{" "}
              <strong>JavaScript, React, and programming fundamentals</strong>.
            </li>
          </ul>

          <h3 className="mt-4">Highlights</h3>
          <ul>
            <li>
              Led front-end development at <strong>datafrik.co</strong>,
              reducing deployment bugs by <strong>30%</strong> and page load
              times by <strong>25%</strong>.
            </li>
            <li>
              Built a state-wide education management solution adopted by{" "}
              <strong>5,000+ educators and students</strong> in Nigeria.
            </li>
            <li>
              Mentored <strong>150+ students</strong> at Udacity, achieving a{" "}
              <strong>90% project completion rate</strong>.
            </li>
            <li>
              Certified in{" "}
              <strong>AWS Cloud, Front-End Development (Udacity)</strong>, and
              passionate about <strong>AI/ML</strong>.
            </li>
          </ul>

          <p className="mt-4 text-justify">
            Let's collaborate to build amazing, user-centric applications!
            Connect with me on{" "}
            <a
              href="http://www.linkedin.com/in/0xonebeing/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>{" "}
            or explore my work on{" "}
            <a
              href="http://www.github.com/0xOneBeing"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  );
}

// import "../App.css";

// export default function AboutMe() {
//   return (
//     <div
//       className="tab-pane fade about=me"
//       id="about-me-tab-pane"
//       role="tabpanel"
//       aria-labelledby="about-me-tab"
//       tabIndex="0"
//     >
//       <section id="about" className="about">
//         <div className="container-fluid">
//           <div className="row">
//             <nav aria-label="breadcrumb">
//               <ol className="breadcrumb">
//                 <li className="breadcrumb-item" aria-current="page">
//                   <small>
//                     <code>$ ~/portfolio/src/components/AboutMe.js</code>
//                   </small>
//                 </li>
//               </ol>
//             </nav>
//           </div>
//           <h5 className="py-4">
//             Hi, I'm Sunday Oruwhone! I'm a passionate Software Engineer & Tutor
//             with a strong focus on Frontend Web Development. Let's build amazing
//             things together.
//           </h5>

//           <div className="container-fluid">
//             <section id="deets">
//               <p>
//                 Professional Bio: A detailed but concise overview of your
//                 background, skills, and experiences.
//               </p>
//               <p>
//                 Education and Certifications: Highlight your academic
//                 achievements and any relevant certifications.
//               </p>
//               <p>
//                 Skills: List your technical skills, programming languages, and
//                 tools you're proficient in.
//               </p>
//               <p>
//                 Personal Interests: Share a bit about your hobbies and interests
//                 to add a personal touch.
//               </p>
//             </section>

//             <section id="resume">
//               <h2>Resume/CV</h2>
//               {/* <!-- Add a link to download your resume --> */}
//               <p>
//                 <a href="path/to/your-resume.pdf" download>
//                   Download Resume
//                 </a>
//               </p>
//             </section>

//             <section id="testimonials">
//               <h2>Testimonials</h2>
//               <blockquote>
//                 <p>
//                   "Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//                   Vivamus ut arcu vitae nulla blandit."
//                 </p>
//                 <footer>- Client Name</footer>
//               </blockquote>
//             </section>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }
